import { render, staticRenderFns } from "./prospeccao.vue?vue&type=template&id=6b622e48&scoped=true"
import script from "./prospeccao.vue?vue&type=script&lang=js"
export * from "./prospeccao.vue?vue&type=script&lang=js"
import style0 from "./prospeccao.vue?vue&type=style&index=0&id=6b622e48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b622e48",
  null
  
)

export default component.exports